import { CustomCountdown } from "./CustomCountdown"

export const LargeCountdown = ({ total, days, hours, minutes, seconds }) => {
    return (
        <CustomCountdown xs={false} days={days} hours={hours} minutes={minutes} seconds={seconds} />
      )
}